import { render, staticRenderFns } from "./tripartiteModal.vue?vue&type=template&id=324ef7f3&scoped=true&"
import script from "./tripartiteModal.vue?vue&type=script&lang=js&"
export * from "./tripartiteModal.vue?vue&type=script&lang=js&"
import style0 from "./tripartiteModal.vue?vue&type=style&index=0&id=324ef7f3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "324ef7f3",
  null
  
)

export default component.exports